import { tablePadding } from "@core/table";
import { tokens } from "@core/theme/tokens";

// Medidas de layout extraídas literalmente de admin.jsx:SegPerfiles
// (:3379-3467) — igual criterio que catalogStyles.ts: DESIGN-TOKENS.md no
// trae escala de espaciado/tamaño, así que estos números viven acá.
export const profileStyles = {
  header: { marginBottom: 22, titleFontSize: 28, subtitleMargin: "6px 0 0" },
  // Cabecera + filas del listado (admin.jsx:3390-3406).
  table: {
    gridTemplateColumns: "1.1fr 2fr 170px 110px 190px",
    gap: 14,
    headerPadding: tablePadding("18px", "11px"),
    rowPadding: tablePadding("14px"),
  },
  badge: { padding: "4px 9px", fontSize: 10 },
  modal: { width: 780, padding: "18px 24px", maxHeight: "62vh" },
  modalHeader: { padding: "20px 24px 16px" },
  modalFooter: { padding: "14px 24px" },
  toggleRow: {
    padding: "12px 14px",
    borderRadius: 13,
    marginBottom: 18,
    gap: 12,
  },
  // Matriz de permisos (admin.jsx:3437-3457).
  matrix: {
    gridTemplateColumns: "1.5fr repeat(4, 92px)",
    gap: 8,
    headerPadding: "14px 18px 10px",
    rowPadding: "11px 18px",
    checkbox: { size: 22, borderRadius: 7 },
  },
  scrim: "rgba(0,0,0,0.5)",
  panel: {
    background: tokens.surface.bg2,
    border: `1px solid ${tokens.surface.line}`,
    borderRadius: tokens.radius.lg,
    boxShadow: tokens.shadow,
  },
} as const;
